import { infiniteQueryOptions } from '@tanstack/react-query'
import getUnapprovedServicePlans from '../api/get-unapproved-service-plans'

export const UNAPPROVED_SERVICE_PLANS_QUERY_KEY = ['unapproved-service-plans']

export const unapprovedServicePlansQueryOptions = infiniteQueryOptions({
  queryKey: UNAPPROVED_SERVICE_PLANS_QUERY_KEY,
  queryFn: ({ pageParam }) => getUnapprovedServicePlans(pageParam),
  initialPageParam: undefined as string | undefined,
  getNextPageParam: lastPage => (lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor : undefined),
  staleTime: 10_000,
})
